export default "__VITE_ASSET__65c82175__"